type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  fillColor?: string;
};

const FacebookVerifiedBadge = (props: Props) => {
  const {
    width = '14',
    height = '14',
    viewBox = '0 0 16 16',
    fillColor = '#1877F2',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
    >
      <path
        d="M8 0L9.66 1.27 11.7 1L12.5 2.93 14.43 3.73 14.16 5.77 15.43 7.43 14.5 9.36 14.93 11.36 13 12.27 12.27 14.16 10.27 14.43 8.36 15.43 6.43 14.16 4.36 14.43 3.43 12.27 1.5 11.36 1.93 9.36 1 7.43 2.27 5.77 2 3.73 3.93 2.93 4.7 1 6.7 1.27z"
        fill={fillColor}
      />
      <path
        d="M6.67 10.4L4.33 8.07 5.27 7.13 6.67 8.53 10.73 4.47 11.67 5.4z"
        fill="#FFFFFF"
      />
    </svg>
  );
};

export default FacebookVerifiedBadge;
